<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 物流管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>箱码查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="运单号" prop="freightBillCode">
                <el-input v-model.trim="searchform.freightBillCode" style="width:100%" clearable placeholder="请输入运单号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batchNo">
                <el-input v-model.trim="searchform.batchNo" style="width:100%" clearable placeholder="请输入批次号"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库单号" prop="outBillCode">
                <el-input v-model.trim="searchform.outBillCode" style="width:100%" clearable placeholder="请输入出库单号"/>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-select v-model="searchform.productCode" placeholder="请输入产品名称模糊匹配或者下拉选择" style="width:100%"
                  :remote-method="getproductlist" filterable remote :loading="productloading" :disabled="show">
                  <el-option v-for="item in productlist" :key="item.product_code" :label="item.product"
                    :value="item.product_code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="箱码" prop="qrcode">
                <el-input v-model.trim="searchform.qrcode" style="width:100%" clearable placeholder="请输入箱码"/>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="年份" prop="queryYear">
                <el-date-picker :picker-options="{ disabledDate: selectYear }"
                  :clearable="false" v-model="searchform.queryYear" type="year" format="yyyy"
                  value-format="yyyy" placeholder="选择年">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['boxcode_select']">搜索</el-button>
              <el-button v-permission="['boxcode_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br />
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>箱码查询</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <el-table-column prop="freightBillCode" label="运单号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="outbillCode" label="出库单号" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="fromWarehouse" label="发货仓库" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerName" label="客户" min-width="220" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="产品" min-width="300" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="码" min-width="170" show-overflow-tooltip></el-table-column>
            <el-table-column prop="packageLevel" label="包装级别" min-width="170" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcodeParent" label="父级码" min-width="170" show-overflow-tooltip></el-table-column>
            <el-table-column prop="scanUnitCode" label="包装单位" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="childNumRelation" label="最小单位数量" min-width="120"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="batchNo" label="出库批次" min-width="100" show-overflow-tooltip></el-table-column>
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="limit"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 50]"
            layout="total,prev, pager, next,jumper,sizes" :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { selectoutbillorderqrcode, basicconfig } from "@/api/physical";
import { productlist } from "@/api/base";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.open();
    this.getproductlist();
    const currentYear = String(new Date().getFullYear());
    this.$set(this.searchform, "queryYear", currentYear);
    basicconfig({ key: "ts_outbillcode_initial_year" }).then(response => {
      // 配置值仅作可选最早年份；筛选项默认当年
      this.year = response.data.confValue;
      this.$set(this.searchform, "queryYear", currentYear);
    });
  },

  data() {
    const currentYear = String(new Date().getFullYear());
    return {
      //基础数据
      year: '',
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //分页数据
      limits: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
      channelType: [
        {
          value: 0,
          label: "配送中心"
        },
        {
          value: 1,
          label: "退货仓"
        }
      ],
      packageLevel: [
        {
          value: 1,
          label: "盒"
        },
        {
          value: 2,
          label: "箱"
        }
      ],
      searchform:
      {
        "page": 1,
        "limit": 10,
        "freightBillCode": "",
        "outBillCode": "",
        "productCode": "",
        "batchNo": "",
        "qrcode": "",
        // 默认当年；resetFields 也会回到该初始值
        queryYear: currentYear
      },
      productloading: false,
      show: false,
      productlist: [] //产品列表下拉
    };
  },
  methods: {
    handleYearChange() {
      // 提取选中的年份
      const selectedYear = this.searchform.queryYear.getFullYear().toString();
      // 将选中的年份存储在 searchform.queryYear 中
      this.searchform.queryYear = selectedYear;
    },
    selectYear(date) {
      // 获取当前年份
      const currentYear = new Date().getFullYear();
      // 获取选择的年份
      const year = date.getFullYear();

      //return year !== parseInt(this.year) && year !== currentYear && year !== currentYear;
      return year < this.year || year > currentYear
    },
    // 获取产品下拉
    getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      selectoutbillorderqrcode(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData);
        this.currentPage = response.data.currPage;
        this.total_count = response.data.totalCount;
        this.listLoading = false;
        console.log(this.tableData);
      });

    },
    // 拼装列表数据
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        obj[i].scan_time = this.$parseTime(obj[i].scan_time);
        obj[i].fromWarehouse =
          (obj[i].fromWarehouseCode || " ") + (obj[i].fromWarehouse || " ");
        obj[i].dealerName =
          (obj[i].dealerCode || " ") + (obj[i].dealerName || " ");
        obj[i].product =
          (obj[i].productCode || " ") + (obj[i].productName || " ");
        switch (obj[i].status) {
          case 0:
            obj[i].status = "未发货";
            break;
          case 1:
            obj[i].status = "已发货";
            break;
          case 2:
            obj[i].status = "已签收";
            break;
          default:
            break;
        }
        switch (obj[i].packageLevel) {
          case 1:
            obj[i].packageLevel = "一级包装";
            break;
          case 2:
            obj[i].packageLevel = "二级包装";
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata(this.searchform);
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
      // 年份不可清空，重置后仍默认当年
      this.searchform.queryYear = String(new Date().getFullYear());
    },
    //分页跳转事件
    currentchange(page) {
      this.searchform.page = page;
      this.Tabledata(this.searchform);
    },
    //分页每页显示条数事件
    limit(limit) {
      this.searchform.limit = limit;
      this.search();
    },
    // 载入提示
    open() {
      const h = this.$createElement;

      this.$notify({
        title: "页面提示",
        message: h("i", "数据量较大，请输入搜索条件进行筛选")
      });
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = this.searchform;
      obj.page = 1;
      obj.limit = this.total_count;
      selectoutbillorderqrcode(obj).then(response => {
        this.tableDataDownload = response.data.list;
        this.packdate(this.tableDataDownload);
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.page;
        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "运单号",
            "出库单号",
            "发货仓库",
            "客户",
            "产品",
            "码",
            "包装级别",
            "父级码",
            "包装单位",
            "最小单位数量",
            "出库批次",
          ];
          const filterVal = [
            "freightBillCode",
            "outbillCode",
            "fromWarehouse",
            "dealerName",
            "product",
            "qrcode",
            "packageLevel",
            "qrcodeParent",
            "scanUnitCode",
            "childNumRelation",
            "batchNo",
          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}

.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}

.handle-box {
  margin-bottom: 0px;
}

.handle-input {
  width: 160px;
  display: inline-block;
}

.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}

.mr10 {
  margin-right: 10px;
}

#parent {
  text-align: center;
}
</style>